export const communityStepsTitles = [
    {
        title: "Create your community page",
        description: "Set up your community page",
    },
];

export const communityGoals = [
    {
        value: "audienceActivation",
        label: "Audience Activation",
        descriptions: [
            "Capture user-generated content on social",
            "Engage with top hosts, aka superfans",
        ],
        similarCommunities: [
            {
                name: "Tim Ferriss",
                link: "https://app.getriver.io/tim",
            },
            {
                name: "Solana Foundation",
                link: "https://app.getriver.io/solana",
            },
        ],
    },
    {
        value: "growth",
        label: "Growth",
        descriptions: [
            "Collect rich data about your community",
            "Identify & activate top prospects",
        ],
        similarCommunities: [
            {
                name: "All-In Podcast",
                link: "https://app.getriver.io/all-in",
            },
            {
                name: "This Week in Startups",
                link: "https://app.getriver.io/twist",
            },
        ],
    },
    {
        value: "ticketingAndMonetization",
        label: "Ticketing and Monetization",
        descriptions: [
            "Produce events for paying members/subscribers",
            "Produce paid/ticketed events",
            "Monetize your events through sponsors",
            "Sell merchandise at point of event registration",
        ],
        similarCommunities: [
            {
                name: "Reading Rhythms",
                link: "https://app.getriver.io/",
            },
        ],
    },
    {
        value: "notSure",
        label: "Not Sure",
        descriptions: [],
        similarCommunities: [],
    },
] as const;

export const monetizationOptions = [
    { value: "free", label: "Free — no charge for attending events" },
    {
        value: "ticketedEvents",
        label: "Ticketed Events — attendees purchase a ticket to attend",
    },
    {
        value: "paidMemberships",
        label: "Paid Memberships — only paying members may host & attend events",
    },
    {
        value: "sponsorships",
        label: "Sponsorships — let local sponsors apply to cover costs or bring a global sponsor for all events",
    },
    {
        value: "reimbursements",
        label: "Reimbursements — let hosts apply for funding and get reimbursed after a successful event",
    },
    {
        value: "merchandise",
        label: "Merchandise — sell merch (such as t-shirts) at the time of event registration",
    },
    { value: "notSure", label: "I’m not sure" },
] as const;

export const hostTypes = [
    { id: "open", label: "Open — anyone from the community can host" },
    {
        id: "vetted",
        label: "Vetted — only those who meet specific criteria can host",
        nestedOptions: [
            { id: "meetProfileCriteria", label: "Meet Profile Criteria" },
            { id: "mustInterview", label: "Must Interview" },
        ],
    },
    {
        id: "partner",
        label: "Partner — hosts with an agreement to produce events",
    },
    { id: "notSure", label: "I’m not sure" },
] as const;
